import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, WhatsappLogo, Check } from "@phosphor-icons/react";
import SectionLabel from "../components/SectionLabel";
import { SERVICES, COMPANY } from "../data/content";

const Services = () => {
  return (
    <>
      <section
        className="border-b border-[var(--sifra-line)] bg-white"
        data-testid="services-hero"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <SectionLabel>Services</SectionLabel>
            <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-6 leading-[1]">
              Hardware is only half the job.
              <br />
              <span className="text-[var(--sifra-ink-mute)]">
                We handle the rest.
              </span>
            </h1>
          </div>
          <div className="md:col-span-4 text-[var(--sifra-ink-soft)]">
            From the first support call to the final warranty claim, our team
            stays on the line until your systems are back up and running.
          </div>
        </div>
      </section>

      <section
        className="bg-[var(--sifra-bg)] border-b border-[var(--sifra-line)]"
        data-testid="services-list"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 space-y-0 border border-[var(--sifra-line)] bg-white">
          {SERVICES.map((s, i) => (
            <div
              key={s.code}
              data-testid={`service-item-${i}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 p-8 md:p-14 group ${
                i < SERVICES.length - 1 ? "border-b border-[var(--sifra-line)]" : ""
              } hover:bg-[var(--sifra-ink)] hover:text-white transition-colors duration-500`}
            >
              <div className="md:col-span-2">
                <div className="text-[11px] tracking-label uppercase text-[var(--sifra-ink-mute)] group-hover:text-white/60">
                  {s.code}
                </div>
              </div>
              <div className="md:col-span-5">
                <h3 className="font-display font-black text-3xl md:text-4xl tracking-tighter">
                  {s.title}
                </h3>
              </div>
              <div className="md:col-span-5 text-[var(--sifra-ink-soft)] group-hover:text-white/70 leading-relaxed">
                <p>{s.body}</p>
                <ul className="mt-5 space-y-2 text-sm">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2">
                      <Check size={14} weight="bold" className="text-[var(--sifra-accent)] group-hover:text-white" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white" data-testid="services-cta">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <SectionLabel>Have an urgent issue?</SectionLabel>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter mt-4">
              Message us on WhatsApp — we'll reply within minutes.
            </h2>
          </div>
          <div className="md:col-span-4 flex md:justify-end gap-3 flex-wrap">
            <a
              href={COMPANY.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-cta-whatsapp"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-4 text-xs tracking-label font-semibold uppercase hover:bg-[#1EBE5D] transition-colors"
            >
              <WhatsappLogo size={16} weight="fill" /> WhatsApp Now
            </a>
            <Link
              to="/contact"
              data-testid="services-cta-contact"
              className="inline-flex items-center gap-2 border border-[var(--sifra-ink)] px-6 py-4 text-xs tracking-label font-semibold uppercase hover:bg-[var(--sifra-ink)] hover:text-white transition-colors"
            >
              Contact <ArrowUpRight size={14} weight="bold" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
